import { render, staticRenderFns } from "./DashboardFiltersPopover.vue?vue&type=template&id=c65c465c&scoped=true"
import script from "./DashboardFiltersPopover.vue?vue&type=script&lang=js"
export * from "./DashboardFiltersPopover.vue?vue&type=script&lang=js"
import style0 from "./DashboardFiltersPopover.vue?vue&type=style&index=0&id=c65c465c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65c465c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c65c465c')) {
      api.createRecord('c65c465c', component.options)
    } else {
      api.reload('c65c465c', component.options)
    }
    module.hot.accept("./DashboardFiltersPopover.vue?vue&type=template&id=c65c465c&scoped=true", function () {
      api.rerender('c65c465c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/dashboard/product-reports-dashboard/DashboardFiltersPopover.vue"
export default component.exports